// Generated by ts-to-zod
import { z } from "zod";
import type { Json } from "./database";

export const jsonSchema: z.ZodSchema<Json> = z.lazy(() =>
  z
    .union([
      z.string(),
      z.number(),
      z.boolean(),
      z.record(z.union([jsonSchema, z.undefined()])),
      z.array(jsonSchema),
    ])
    .nullable()
);

export const analyticsRowSchema = z.object({
  created_at: z.string().nullable(),
  id: z.number(),
  map_id: z.string(),
  metadata: jsonSchema,
  name: z.string(),
  session: z.string(),
  workspace_id: z.string(),
});

export const analyticsInsertSchema = z.object({
  created_at: z.string().optional().nullable(),
  id: z.number().optional(),
  map_id: z.string(),
  metadata: jsonSchema,
  name: z.string(),
  session: z.string().optional(),
  workspace_id: z.string(),
});

export const analyticsUpdateSchema = z.object({
  created_at: z.string().optional().nullable(),
  id: z.number().optional(),
  map_id: z.string().optional(),
  metadata: jsonSchema.optional(),
  name: z.string().optional(),
  session: z.string().optional(),
  workspace_id: z.string().optional(),
});

export const boundariesRowSchema = z.object({
  created_at: z.string().nullable(),
  geometry: z.unknown().nullable(),
  id: z.string(),
  place_name: z.string(),
  place_type: z.string(),
  updated_at: z.string().nullable(),
});

export const boundariesInsertSchema = z.object({
  created_at: z.string().optional().nullable(),
  geometry: z.unknown().optional().nullable(),
  id: z.string().optional(),
  place_name: z.string(),
  place_type: z.string(),
  updated_at: z.string().optional().nullable(),
});

export const boundariesUpdateSchema = z.object({
  created_at: z.string().optional().nullable(),
  geometry: z.unknown().optional().nullable(),
  id: z.string().optional(),
  place_name: z.string().optional(),
  place_type: z.string().optional(),
  updated_at: z.string().optional().nullable(),
});

export const categoriesRowSchema = z.object({
  created_at: z.string().nullable(),
  created_by: z.string(),
  deleted: z.boolean(),
  id: z.string(),
  map_id: z.string(),
  sort_order: z.string(),
  styles: jsonSchema.nullable(),
  title: z.string(),
  updated_at: z.string().nullable(),
  updated_by: z.string(),
  visible: z.boolean().nullable(),
  workspace_id: z.string(),
});

export const categoriesInsertSchema = z.object({
  created_at: z.string().optional().nullable(),
  created_by: z.string(),
  deleted: z.boolean().optional(),
  id: z.string().optional(),
  map_id: z.string(),
  sort_order: z.string(),
  styles: jsonSchema.optional().nullable(),
  title: z.string(),
  updated_at: z.string().optional().nullable(),
  updated_by: z.string(),
  visible: z.boolean().optional().nullable(),
  workspace_id: z.string(),
});

export const categoriesUpdateSchema = z.object({
  created_at: z.string().optional().nullable(),
  created_by: z.string().optional(),
  deleted: z.boolean().optional(),
  id: z.string().optional(),
  map_id: z.string().optional(),
  sort_order: z.string().optional(),
  styles: jsonSchema.optional().nullable(),
  title: z.string().optional(),
  updated_at: z.string().optional().nullable(),
  updated_by: z.string().optional(),
  visible: z.boolean().optional().nullable(),
  workspace_id: z.string().optional(),
});

export const connectionsRowSchema = z.object({
  column_map: jsonSchema,
  config: jsonSchema,
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  id: z.string(),
  last_sync: z.string().nullable(),
  auto_sync: z.boolean().optional(),
  sync_frequency: z.string().optional().nullable(),
  map_id: z.string(),
  title: z.string(),
  updated_at: z.string().nullable(),
  updated_by: z.string().nullable(),
  workspace_id: z.string(),
});

export const connectionsInsertSchema = z.object({
  column_map: jsonSchema.optional(),
  config: jsonSchema.optional(),
  created_at: z.string().optional().nullable(),
  created_by: z.string().optional().nullable(),
  id: z.string().optional(),
  last_sync: z.string().optional().nullable(),
  auto_sync: z.boolean().optional(),
  sync_frequency: z.string().optional().nullable(),
  map_id: z.string(),
  title: z.string(),
  updated_at: z.string().optional().nullable(),
  updated_by: z.string().optional().nullable(),
  workspace_id: z.string(),
});

export const connectionsUpdateSchema = z.object({
  column_map: jsonSchema.optional(),
  config: jsonSchema.optional(),
  created_at: z.string().optional().nullable(),
  created_by: z.string().optional().nullable(),
  id: z.string().optional(),
  last_sync: z.string().optional().nullable(),
  auto_sync: z.boolean().optional(),
  sync_frequency: z.string().optional().nullable(),
  map_id: z.string().optional(),
  title: z.string().optional(),
  updated_at: z.string().optional().nullable(),
  updated_by: z.string().optional().nullable(),
  workspace_id: z.string().optional(),
});

export const crowdsourcedRowSchema = z.object({
  category_id: z.string().nullable(),
  created_at: z.string().nullable(),
  custom_values: jsonSchema.nullable(),
  deleted: z.boolean().nullable(),
  description: z.string().nullable(),
  geometry: z.unknown(),
  id: z.string(),
  map_id: z.string(),
  medias: jsonSchema.nullable(),
  properties: jsonSchema,
  read: z.boolean().nullable(),
  title: z.string(),
  updated_at: z.string().nullable(),
  workspace_id: z.string(),
});

export const crowdsourcedInsertSchema = z.object({
  category_id: z.string().optional().nullable(),
  created_at: z.string().optional().nullable(),
  custom_values: jsonSchema.optional().nullable(),
  deleted: z.boolean().optional().nullable(),
  description: z.string().optional().nullable(),
  geometry: z.unknown(),
  id: z.string().optional(),
  map_id: z.string(),
  medias: jsonSchema.optional().nullable(),
  properties: jsonSchema.optional(),
  read: z.boolean().optional().nullable(),
  title: z.string(),
  updated_at: z.string().optional().nullable(),
  workspace_id: z.string(),
});

export const crowdsourcedUpdateSchema = z.object({
  category_id: z.string().optional().nullable(),
  created_at: z.string().optional().nullable(),
  custom_values: jsonSchema.optional().nullable(),
  deleted: z.boolean().optional().nullable(),
  description: z.string().optional().nullable(),
  geometry: z.unknown().optional(),
  id: z.string().optional(),
  map_id: z.string().optional(),
  medias: jsonSchema.optional().nullable(),
  properties: jsonSchema.optional(),
  read: z.boolean().optional().nullable(),
  title: z.string().optional(),
  updated_at: z.string().optional().nullable(),
  workspace_id: z.string().optional(),
});

export const featuresRowSchema = z.object({
  actions: jsonSchema,
  approved: z.boolean().nullable(),
  category_id: z.string().nullable(),
  connection_id: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string(),
  deleted: z.boolean(),
  description: z.string().nullable(),
  geometry: z.unknown(),
  id: z.string(),
  locked: z.boolean().nullable(),
  map_id: z.string(),
  properties: jsonSchema,
  sort_order: z.string(),
  styles: jsonSchema.nullable(),
  summary: z.string().nullable(),
  title: z.string(),
  updated_at: z.string().nullable(),
  updated_by: z.string(),
  visible: z.boolean().nullable(),
  workspace_id: z.string(),
});

export const featuresInsertSchema = z.object({
  actions: jsonSchema.optional(),
  approved: z.boolean().optional().nullable(),
  category_id: z.string().optional().nullable(),
  connection_id: z.string().optional().nullable(),
  created_at: z.string().optional().nullable(),
  created_by: z.string(),
  deleted: z.boolean().optional(),
  description: z.string().optional().nullable(),
  geometry: z.unknown(),
  id: z.string().optional(),
  locked: z.boolean().optional().nullable(),
  map_id: z.string(),
  properties: jsonSchema.optional(),
  sort_order: z.string(),
  styles: jsonSchema.optional().nullable(),
  summary: z.string().optional().nullable(),
  title: z.string(),
  updated_at: z.string().optional().nullable(),
  updated_by: z.string(),
  visible: z.boolean().optional().nullable(),
  workspace_id: z.string(),
});

export const featuresUpdateSchema = z.object({
  actions: jsonSchema.optional(),
  approved: z.boolean().optional().nullable(),
  category_id: z.string().optional().nullable(),
  connection_id: z.string().optional().nullable(),
  created_at: z.string().optional().nullable(),
  created_by: z.string().optional(),
  deleted: z.boolean().optional(),
  description: z.string().optional().nullable(),
  geometry: z.unknown().optional(),
  id: z.string().optional(),
  locked: z.boolean().optional().nullable(),
  map_id: z.string().optional(),
  properties: jsonSchema.optional(),
  sort_order: z.string().optional(),
  styles: jsonSchema.optional().nullable(),
  summary: z.string().optional().nullable(),
  title: z.string().optional(),
  updated_at: z.string().optional().nullable(),
  updated_by: z.string().optional(),
  visible: z.boolean().optional().nullable(),
  workspace_id: z.string().optional(),
});

export const filtersRowSchema = z.object({
  created_at: z.string().nullable(),
  created_by: z.string(),
  enabled: z.boolean().nullable(),
  id: z.string(),
  map_id: z.string(),
  sort_order: z.string(),
  title: z.string(),
  type: z.string(),
  updated_at: z.string().nullable(),
  updated_by: z.string(),
  workspace_id: z.string(),
});

export const filtersInsertSchema = z.object({
  created_at: z.string().optional().nullable(),
  created_by: z.string(),
  enabled: z.boolean().optional().nullable(),
  id: z.string().optional(),
  map_id: z.string(),
  sort_order: z.string(),
  title: z.string(),
  type: z.string(),
  updated_at: z.string().optional().nullable(),
  updated_by: z.string(),
  workspace_id: z.string(),
});

export const filtersUpdateSchema = z.object({
  created_at: z.string().optional().nullable(),
  created_by: z.string().optional(),
  enabled: z.boolean().optional().nullable(),
  id: z.string().optional(),
  map_id: z.string().optional(),
  sort_order: z.string().optional(),
  title: z.string().optional(),
  type: z.string().optional(),
  updated_at: z.string().optional().nullable(),
  updated_by: z.string().optional(),
  workspace_id: z.string().optional(),
});

export const layersRowSchema = z.object({
  config: jsonSchema.nullable(),
  created_at: z.string().nullable(),
  created_by: z.string(),
  id: z.number(),
  name: z.string().nullable(),
  palette: jsonSchema.nullable(),
  private_key: z.string().nullable(),
  updated_at: z.string().nullable(),
  updated_by: z.string(),
  url: z.string().nullable(),
  workspace_id: z.string(),
});

export const layersInsertSchema = z.object({
  config: jsonSchema.optional().nullable(),
  created_at: z.string().optional().nullable(),
  created_by: z.string(),
  id: z.number().optional(),
  name: z.string().optional().nullable(),
  palette: jsonSchema.optional().nullable(),
  private_key: z.string().optional().nullable(),
  updated_at: z.string().optional().nullable(),
  updated_by: z.string(),
  url: z.string().optional().nullable(),
  workspace_id: z.string(),
});

export const layersUpdateSchema = z.object({
  config: jsonSchema.optional().nullable(),
  created_at: z.string().optional().nullable(),
  created_by: z.string().optional(),
  id: z.number().optional(),
  name: z.string().optional().nullable(),
  palette: jsonSchema.optional().nullable(),
  private_key: z.string().optional().nullable(),
  updated_at: z.string().optional().nullable(),
  updated_by: z.string().optional(),
  url: z.string().optional().nullable(),
  workspace_id: z.string().optional(),
});

export const mediasRowSchema = z.object({
  created_at: z.string().nullable(),
  created_by: z.string(),
  deleted: z.boolean(),
  // feature_id: z.string(),
  file: z.string(),
  id: z.string(),
  map_id: z.string().nullable(),
  type: z.string(),
  provider: z.enum(["supabase", "cloudflare"]).default("supabase"),
  updated_at: z.string().nullable(),
  updated_by: z.string(),
  workspace_id: z.string(),
});

export const mediasInsertSchema = z.object({
  created_at: z.string().optional().nullable(),
  created_by: z.string(),
  deleted: z.boolean().optional(),
  file: z.string(),
  id: z.string().optional(),
  map_id: z.string().optional().nullable(),
  type: z.string().optional(),
  provider: z.enum(["supabase", "cloudflare"]).default("supabase"),
  updated_at: z.string().optional().nullable(),
  updated_by: z.string(),
  workspace_id: z.string(),
});

export const mediasUpdateSchema = z.object({
  created_at: z.string().optional().nullable(),
  created_by: z.string().optional(),
  deleted: z.boolean().optional(),
  file: z.string().optional(),
  id: z.string().optional(),
  map_id: z.string().optional().nullable(),
  type: z.string().optional(),
  updated_at: z.string().optional().nullable(),
  updated_by: z.string().optional(),
  workspace_id: z.string().optional(),
});

export const sessionsRowSchema = z.object({
  created_at: z.string().nullable(),
  data: jsonSchema.nullable(),
  expires: z.string().nullable(),
  id: z.string(),
});

export const sessionsInsertSchema = z.object({
  created_at: z.string().optional().nullable(),
  data: jsonSchema.optional().nullable(),
  expires: z.string().optional().nullable(),
  id: z.string().optional(),
});

export const sessionsUpdateSchema = z.object({
  created_at: z.string().optional().nullable(),
  data: jsonSchema.optional().nullable(),
  expires: z.string().optional().nullable(),
  id: z.string().optional(),
});

export const spatialRefSysRowSchema = z.object({
  auth_name: z.string().nullable(),
  auth_srid: z.number().nullable(),
  proj4text: z.string().nullable(),
  srid: z.number(),
  srtext: z.string().nullable(),
});

export const spatialRefSysInsertSchema = z.object({
  auth_name: z.string().optional().nullable(),
  auth_srid: z.number().optional().nullable(),
  proj4text: z.string().optional().nullable(),
  srid: z.number(),
  srtext: z.string().optional().nullable(),
});

export const spatialRefSysUpdateSchema = z.object({
  auth_name: z.string().optional().nullable(),
  auth_srid: z.number().optional().nullable(),
  proj4text: z.string().optional().nullable(),
  srid: z.number().optional(),
  srtext: z.string().optional().nullable(),
});

export const themesRowSchema = z.object({
  config: jsonSchema.nullable(),
  created_at: z.string().nullable(),
  id: z.string(),
  name: z.string().nullable(),
  palette: jsonSchema.nullable(),
  session: z.string(),
  updated_at: z.string().nullable(),
});

export const themesInsertSchema = z.object({
  config: jsonSchema.optional().nullable(),
  created_at: z.string().optional().nullable(),
  id: z.string().optional(),
  name: z.string().optional().nullable(),
  palette: jsonSchema.optional().nullable(),
  session: z.string(),
  updated_at: z.string().optional().nullable(),
});

export const themesUpdateSchema = z.object({
  config: jsonSchema.optional().nullable(),
  created_at: z.string().optional().nullable(),
  id: z.string().optional(),
  name: z.string().optional().nullable(),
  palette: jsonSchema.optional().nullable(),
  session: z.string().optional(),
  updated_at: z.string().optional().nullable(),
});

export const usersRowSchema = z.object({
  avatar_url: z.string().nullable(),
  created_at: z.string().nullable(),
  email: z.string().nullable(),
  full_name: z.string().nullable(),
  id: z.string(),
  preferences: jsonSchema,
  updated_at: z.string().nullable(),
});

export const usersInsertSchema = z.object({
  avatar_url: z.string().optional().nullable(),
  created_at: z.string().optional().nullable(),
  email: z.string().optional().nullable(),
  full_name: z.string().optional().nullable(),
  id: z.string(),
  preferences: jsonSchema.optional(),
  updated_at: z.string().optional().nullable(),
});

export const usersUpdateSchema = z.object({
  avatar_url: z.string().optional().nullable(),
  created_at: z.string().optional().nullable(),
  email: z.string().optional().nullable(),
  full_name: z.string().optional().nullable(),
  id: z.string().optional(),
  preferences: jsonSchema.optional(),
  updated_at: z.string().optional().nullable(),
});

export const workspacesRowSchema = z.object({
  created_at: z.string().nullable(),
  id: z.string(),
  name: z.string(),
  owner_id: z.string(),
  settings: jsonSchema.nullable(),
  slug: z.string(),
  updated_at: z.string().nullable(),
});

export const workspacesInsertSchema = z.object({
  created_at: z.string().optional().nullable(),
  id: z.string().optional(),
  name: z.string(),
  owner_id: z.string(),
  settings: jsonSchema.optional().nullable(),
  slug: z.string(),
  updated_at: z.string().optional().nullable(),
});

export const workspacesUpdateSchema = z.object({
  created_at: z.string().optional().nullable(),
  id: z.string().optional(),
  name: z.string().optional(),
  owner_id: z.string().optional(),
  settings: jsonSchema.optional().nullable(),
  slug: z.string().optional(),
  updated_at: z.string().optional().nullable(),
});

export const geographyColumnsRowSchema = z.object({
  coord_dimension: z.number().nullable(),
  f_geography_column: z.unknown().nullable(),
  f_table_catalog: z.unknown().nullable(),
  f_table_name: z.unknown().nullable(),
  f_table_schema: z.unknown().nullable(),
  srid: z.number().nullable(),
  type: z.string().nullable(),
});

export const geometryColumnsRowSchema = z.object({
  coord_dimension: z.number().nullable(),
  f_geometry_column: z.unknown().nullable(),
  f_table_catalog: z.string().nullable(),
  f_table_name: z.unknown().nullable(),
  f_table_schema: z.unknown().nullable(),
  srid: z.number().nullable(),
  type: z.string().nullable(),
});

export const geometryColumnsInsertSchema = z.object({
  coord_dimension: z.number().optional().nullable(),
  f_geometry_column: z.unknown().optional().nullable(),
  f_table_catalog: z.string().optional().nullable(),
  f_table_name: z.unknown().optional().nullable(),
  f_table_schema: z.unknown().optional().nullable(),
  srid: z.number().optional().nullable(),
  type: z.string().optional().nullable(),
});

export const geometryColumnsUpdateSchema = z.object({
  coord_dimension: z.number().optional().nullable(),
  f_geometry_column: z.unknown().optional().nullable(),
  f_table_catalog: z.string().optional().nullable(),
  f_table_name: z.unknown().optional().nullable(),
  f_table_schema: z.unknown().optional().nullable(),
  srid: z.number().optional().nullable(),
  type: z.string().optional().nullable(),
});

export const currentUserAccountRoleReturnsSchema = jsonSchema;

export const getWorkspaceBillingStatusReturnsSchema = jsonSchema;

export const jsonReturnsSchema = jsonSchema;

export const jsonbReturnsSchema = jsonSchema;

export const lookupInvitationReturnsSchema = jsonSchema;

export const invitationTypeSchema = z.union([
  z.literal("one-time"),
  z.literal("24-hour"),
]);

export const mapAccessSchema = z.union([
  z.literal("public"),
  z.literal("protected"),
  z.literal("private"),
]);

export const pricingPlanIntervalSchema = z.union([
  z.literal("day"),
  z.literal("week"),
  z.literal("month"),
  z.literal("year"),
]);

export const pricingTypeSchema = z.union([
  z.literal("one_time"),
  z.literal("recurring"),
]);

export const subscriptionStatusSchema = z.union([
  z.literal("trialing"),
  z.literal("active"),
  z.literal("canceled"),
  z.literal("incomplete"),
  z.literal("incomplete_expired"),
  z.literal("past_due"),
  z.literal("unpaid"),
  z.literal("paused"),
]);

export const workspaceRoleSchema = z.union([
  z.literal("owner"),
  z.literal("member"),
]);

export const invitationsRowSchema = z.object({
  created_at: z.string().nullable(),
  email: z.string(),
  id: z.string(),
  invitation_type: invitationTypeSchema.nullable(),
  invite_url: z.string().nullable(),
  invited_by_user_id: z.string(),
  role: workspaceRoleSchema,
  token: z.string(),
  updated_at: z.string().nullable(),
  workspace_id: z.string(),
  workspace_name: z.string().nullable(),
});

export const invitationsInsertSchema = z.object({
  created_at: z.string().optional().nullable(),
  email: z.string(),
  id: z.string().optional(),
  invitation_type: invitationTypeSchema.optional().nullable(),
  invite_url: z.string().optional().nullable(),
  invited_by_user_id: z.string(),
  role: workspaceRoleSchema,
  token: z.string().optional(),
  updated_at: z.string().optional().nullable(),
  workspace_id: z.string(),
  workspace_name: z.string().optional().nullable(),
});

export const invitationsUpdateSchema = z.object({
  created_at: z.string().optional().nullable(),
  email: z.string().optional(),
  id: z.string().optional(),
  invitation_type: invitationTypeSchema.optional().nullable(),
  invite_url: z.string().optional().nullable(),
  invited_by_user_id: z.string().optional(),
  role: workspaceRoleSchema.optional(),
  token: z.string().optional(),
  updated_at: z.string().optional().nullable(),
  workspace_id: z.string().optional(),
  workspace_name: z.string().optional().nullable(),
});

export const mapsRowSchema = z.object({
  access: mapAccessSchema,
  allow_crowdsourcing: z.boolean().nullable(),
  allow_duplication: z.boolean().nullable(),
  center: jsonSchema,
  controls: jsonSchema,
  created_at: z.string().nullable(),
  created_by: z.string(),
  deleted: z.boolean(),
  description: z.string().nullable(),
  enable_clustering: z.boolean().nullable(),
  id: z.string(),
  password: z.string().nullable(),
  search: jsonSchema,
  styles: jsonSchema,
  title: z.string(),
  updated_at: z.string().nullable(),
  updated_by: z.string(),
  workspace_id: z.string(),
});

export const mapsInsertSchema = z.object({
  access: mapAccessSchema.optional(),
  allow_crowdsourcing: z.boolean().optional().nullable(),
  allow_duplication: z.boolean().optional().nullable(),
  center: jsonSchema.optional(),
  controls: jsonSchema.optional(),
  created_at: z.string().optional().nullable(),
  created_by: z.string(),
  deleted: z.boolean().optional(),
  description: z.string().optional().nullable(),
  enable_clustering: z.boolean().optional().nullable(),
  id: z.string().optional(),
  password: z.string().optional().nullable(),
  search: jsonSchema.optional(),
  styles: jsonSchema.optional(),
  title: z.string(),
  updated_at: z.string().optional().nullable(),
  updated_by: z.string(),
  workspace_id: z.string(),
});

export const mapsUpdateSchema = z.object({
  access: mapAccessSchema.optional(),
  allow_crowdsourcing: z.boolean().optional().nullable(),
  allow_duplication: z.boolean().optional().nullable(),
  center: jsonSchema.optional(),
  controls: jsonSchema.optional(),
  created_at: z.string().optional().nullable(),
  created_by: z.string().optional(),
  deleted: z.boolean().optional(),
  description: z.string().optional().nullable(),
  enable_clustering: z.boolean().optional().nullable(),
  id: z.string().optional(),
  password: z.string().optional().nullable(),
  search: jsonSchema.optional(),
  styles: jsonSchema.optional(),
  title: z.string().optional(),
  updated_at: z.string().optional().nullable(),
  updated_by: z.string().optional(),
  workspace_id: z.string().optional(),
});

export const workspaceUsersRowSchema = z.object({
  created_at: z.string().nullable(),
  role: workspaceRoleSchema,
  updated_at: z.string().nullable(),
  user_id: z.string(),
  workspace_id: z.string(),
});

export const workspaceUsersInsertSchema = z.object({
  created_at: z.string().optional().nullable(),
  role: workspaceRoleSchema,
  updated_at: z.string().optional().nullable(),
  user_id: z.string(),
  workspace_id: z.string(),
});

export const workspaceUsersUpdateSchema = z.object({
  created_at: z.string().optional().nullable(),
  role: workspaceRoleSchema.optional(),
  updated_at: z.string().optional().nullable(),
  user_id: z.string().optional(),
  workspace_id: z.string().optional(),
});

export const leadFormsRowSchema = z.object({
  id: z.string(),
  workspace_id: z.string(),
  created_by: z.string(),
  updated_by: z.string(),
  title: z.string(),
  description: z.string().optional().nullable(),
  schema: z.record(z.any()).default({}),
  messages: z
    .object({
      role: z.enum(["user", "assistant", "system"]),
      content: z.string(),
    })
    .array()
    .optional()
    .default([]),
  status: z.enum(["draft", "published", "archived"]).default("draft"),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
});

export const leadFormsInsertSchema = leadFormsRowSchema.partial({
  id: true,
  created_at: true,
  updated_at: true,
});

export const leadFormUpdateSchema = leadFormsRowSchema.partial().extend({
  id: z.string(),
});

const Geometry: z.ZodType<GeoJSON.Geometry> = z.any();
const Properties: z.ZodType<GeoJSON.GeoJsonProperties> = z.record(z.any());

export const savedElementsRowSchema = z.object({
  id: z.string(),
  workspace_id: z.string(),
  user_id: z.string(),
  name: z.string(),
  type: z.enum(["line", "polygon", "other", "circle"]),
  geometry: Geometry, // Using unknown for geometry type
  properties: Properties,
  styles: z.record(z.any()).optional().nullable(),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
});

export const savedElementsInsertSchema = z.object({
  id: z.string().optional(),
  workspace_id: z.string(),
  user_id: z.string(),
  name: z.string(),
  type: z.enum(["line", "polygon", "other", "circle"]),
  geometry: Geometry,
  properties: Properties,
  styles: z.record(z.any()).optional().nullable(),
  created_at: z.string().optional().nullable(),
  updated_at: z.string().optional().nullable(),
});

export const savedElementsUpdateSchema = z.object({
  id: z.string().optional(),
  workspace_id: z.string().optional(),
  user_id: z.string().optional(),
  name: z.string().optional(),
  type: z.enum(["line", "polygon", "other", "circle"]).optional(),
  geometry: Geometry.optional(),
  properties: Properties.optional(),
  styles: z.record(z.any()).optional().nullable(),
  created_at: z.string().optional().nullable(),
  updated_at: z.string().optional().nullable(),
});

export const leadFormMapsRowSchema = z.object({
  id: z.string(),
  lead_form_id: z.string(),
  workspace_id: z.string(),
  map_id: z.string(),
  slot: z.enum(["global", "feature", "crowdsource", "popup"]).default("global"),
});

export const leadFormSubmissionRowSchema = z.object({
  id: z.string(),
  lead_form_id: z.string(),
  workspace_id: z.string(),
  map_id: z.string(),
  geometry: z.unknown(),
  status: z.enum(["pending", "approved", "rejected"]).default("pending"),
  properties: z.record(z.any()).optional().default({}),
  category_id: z.string().optional().nullable(),
  data: z.array(z.any()).default([]),
  created_at: z.string(),
  updated_at: z.string(),
});
